import { Container } from 'inversify';
import { initAdvertFavoriteService, initAdvertListData, initLanguageControl } from '@edikk-edikk/ui';
import { initDiContainer as initDiContainerDefault } from '@edikk-edikk/di-container';
import { initApi } from '#srcJs/inversify/init-api';
import { LANGUAGE_CODE_DEFAULT, LANGUAGE_CODE_LIST } from '#components/language/constants';
import { initFeature } from '#srcJs/inversify/init-feature';

const initDiContainer = (): Container => initDiContainerDefault((diContainer: Container) => {
  initAdvertFavoriteService(diContainer);
  initAdvertListData(diContainer);
  initLanguageControl(diContainer, LANGUAGE_CODE_LIST, LANGUAGE_CODE_DEFAULT);
  initApi(diContainer);
  initFeature(diContainer);
});

export { initDiContainer };
